import { Module } from '@/modules/core/app/constants/app.constants';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import {
  ReportingProfileRoute,
  ReportingProfilePathName,
} from '@/modules/ta/reportingprofile/reportingprofile.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${ReportingProfileRoute.REPORTINGPROFILES}`,
      name: ReportingProfilePathName.REPORTINGPROFILES,
      component: () =>
        import(
          /* webpackChunkName: "reportingprofiles-page" */ './pages/ReportingProfilesPage.vue'
        ),
    },
    {
      path: `/${ReportingProfileRoute.REPORTINGPROFILES}/add`, // This route name is temporary to match with legacy app route to trigger angular app
      name: ReportingProfilePathName.REPORTINGPROFILESFORM_NEW,
      component: () =>
        import(
          /* webpackChunkName: "reportingprofileadd-page" */ '@/modules/legacy/reportingprofile/pages/ReportingProfileDetailPage.vue'
        ),
    },
    {
      path: `/${ReportingProfileRoute.REPORTINGPROFILES}/:id`,
      name: ReportingProfilePathName.REPORTINGPROFILESFORM,
      component: () =>
        import(
          /* webpackChunkName: "reportingprofiledetail-page" */ '@/modules/legacy/reportingprofile/pages/ReportingProfileDetailPage.vue'
        ),
    },
    {
      path: `/${ReportingProfileRoute.REPORTINGPROFILES}/detail_show_all_services/:id`,
      name: ReportingProfilePathName.REPORTINGPROFILEDETAIL,
      component: () =>
        import(
          /* webpackChunkName: "reportingprofiledetail-page" */ '@/modules/legacy/reportingprofile/pages/ReportingProfileDetailPage.vue'
        ),
    },
  ],
  Module.REPORTINGPROFILE
);
